/* eslint-disable @typescript-eslint/prefer-for-of */
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { ToastController } from "@ionic/angular";

export class Helper {

    private static toastController: ToastController = new ToastController();

    private static presentFocusFallback(): void{
        Helper.toastController.create({
            message: 'Existem campos inválidos ou não preenchidos. Revise os dados e tente novamente.',
            duration: 3000,
            color: 'danger',
            mode: 'ios',
            position: 'bottom'
        }).then((toast) => toast.present());
    }

    public static focusInvalid(f: FormGroup){

        let has = false;

        const check = (field: FormControl, chave: string) => {
            if(!has){
                if(field.invalid){
                    has = true;
                    const invalidControl = document.querySelector('[formControlName="' + chave + '"],[ng-reflect-name="' + chave + '"]') as HTMLInputElement;
                    if(invalidControl){
                        if(invalidControl.nodeName == 'INPUT'){
                            invalidControl.focus();
                        }else if(invalidControl.nodeName == 'EDITOR'){
                            var editors = invalidControl.getElementsByTagName('iframe');
                            if (editors !== undefined && editors.length > 0) {
                                var editor = editors[0];
                                var body = editor.contentDocument?.getElementsByTagName('body');
                                if (body !== undefined && body.length > 0) {
                                    body[0].focus();
                                }
                            }
                        }else if(invalidControl.nodeName == 'SELECT'){
                            invalidControl.focus();
                        }else{
                            console.log("IMPLEMENTAR FOCO ON INVALID", field, chave, invalidControl);
                            // Helper.presentFocusFallback();
                        }
                    }else{
                        console.log("IMPLEMENTAR FOCO ON INVALID", field, chave, invalidControl);
                        // Helper.presentFocusFallback();
                    }
                }
            }
        };

        const percorre = (form: FormGroup) => {
            for (const key of Object.keys(form.controls)) {
                if(has){
                    break;
                }
                if(form.get(key) instanceof FormArray){
                    for(let i = 0; i < (form.get(key) as FormArray).length; i++){
                        if(has){
                            break;
                        }
                        if((form.get(key) as FormArray).at(i) instanceof FormGroup){
                            percorre((form.get(key) as FormArray).at(i) as FormGroup);
                        }else{
                            check((form.get(key) as FormArray).at(i) as FormControl, key);
                        }
                    }
                }else{
                    if(form.get(key) instanceof FormGroup){
                        percorre(form.get(key) as FormGroup);
                    }else{
                        check(form.get(key) as FormControl, key);
                    }
                }
            }
        };

        percorre(f);

        Helper.presentFocusFallback();

    }

    public static parseBool(v: any): boolean | undefined{
            if(v === undefined || v === null){
                return undefined;
            }
            if(typeof v == 'boolean'){
                return v;
            }
            if(typeof v == 'number'){
                return v == 1;
            }
            if(typeof v == 'string'){
                const value = v.trim().toLowerCase();
                if(value == '1' || value == 'true' || value == 'sim' || value == 'yes'){
                    return true;
                }
                if(value == '0' || value == 'false' || value == 'nao' || value == 'não' || value == 'no'){
                    return false;
                }
            }
            return undefined;
        }

    public static ordenarItensChecklist<T>(
        itens: T[],
        valor: (item: T) => any = (item) => item
    ): T[] {
        const grupos = new Map<string, {indice: number; ordem: number | null}>();
        const decorados = itens.map((item, indice) => {
            const dados = valor(item) || {};
            const grupo = Helper.normalizarGrupoChecklist(dados.agrupar || dados.tab);
            const grupoOrdem = Helper.numeroOrNull(dados.grupo_ordem ?? dados.metadata?.grupo_ordem);
            const existente = grupos.get(grupo);

            if(!existente){
                grupos.set(grupo, {indice: grupos.size, ordem: grupoOrdem});
            }else if(existente.ordem === null && grupoOrdem !== null){
                existente.ordem = grupoOrdem;
            }

            return {
                item,
                indice,
                grupo,
                ordem: Helper.numeroOrNull(dados.ordem),
            };
        });

        decorados.sort((a, b) => {
            const grupoA = grupos.get(a.grupo)!;
            const grupoB = grupos.get(b.grupo)!;

            return ((grupoA.ordem ?? Number.MAX_SAFE_INTEGER) - (grupoB.ordem ?? Number.MAX_SAFE_INTEGER))
                || (grupoA.indice - grupoB.indice)
                || ((a.ordem ?? Number.MAX_SAFE_INTEGER) - (b.ordem ?? Number.MAX_SAFE_INTEGER))
                || (a.indice - b.indice);
        });

        return decorados.map(({item}) => item);
    }

    public static normalizarGrupoChecklist(valor: unknown): string {
        const grupo = valor === null || valor === undefined ? '' : String(valor).trim();
        return grupo || 'Itens';
    }

    private static numeroOrNull(valor: unknown): number | null {
        if(valor === null || valor === undefined || valor === ''){
            return null;
        }

        const numero = Number(valor);
        return Number.isFinite(numero) ? numero : null;
    }

}
